import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  currentUserDataSelector,
  store,
  feesSavedDefault,
  employerNewDataSelector,
} from '@plootus/common';
import axios from 'axios';
import moment from 'moment';

const selectStrategy = (data, strategy) => {
  switch (strategy) {
    case 0:
      return data[0]?.superconservative;
    case 1:
      return data[0]?.conservative;
    case 2:
      return data[0]?.moderate;
    case 3:
      return data[0]?.growth;
    case 4:
      return data[0]?.supergrowth;
    default:
      return null;
  }
};

export const useFeesSaved = (strategy, manualFees = null, manualCreatedAt = null) => {
  const token = useSelector(({ userReducer }) => userReducer?.token);
  const userData = useSelector(currentUserDataSelector);
  const [graphData, setGraphData] = useState({
    data: [],
    total: 0,
    flag: null,
    saved: 0,
  });

  const [feesSavedData, setFeesSavedData] = useState([]);

  const employerEin = userData?.employerEin;
  const sponsor_name = userData?.sponsor_name;

  const { employer_selected, selected_ein } = useSelector(
    employerNewDataSelector
  );
  const createdAt = manualCreatedAt || (userData?.createdAt ? userData?.createdAt : moment.now());

  useEffect(() => {
    if (manualFees) {
      setFeesSavedData(manualFees);
      return;
    }
    (async () => {
      try {
        if (token) {
          const response = await axios.get(
            `https://www.plootus.com/api/employee/getfeessaved?ein=${
              selected_ein ? selected_ein : employerEin
            }`,
            {
              headers: {
                Authorization: token,
              },
            }
          );
          setFeesSavedData(response.data?.fees);
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, [sponsor_name, employer_selected, manualFees]);

  useEffect(() => {
    if ((selected_ein || employerEin || manualFees) && feesSavedData.length) {
      // feesSavedData is used incase data is empty from backend
      const tempData = selectStrategy(
        feesSavedData,
        selected_ein || employerEin || manualFees ? strategy : 3
      );
      let temp = [];
      let tot = 0;
      for (let i = 0; i < tempData?.length; ++i) {
        temp.push({
          x: parseInt(moment(createdAt).format('YYYY')) + i,
          y: tempData[i],
        });
        tot += tempData[i];
      }
      // console.log('checking fees saving');
      // console.log(tot);
      // console.log(temp[temp.length - 1]);
      setGraphData({
        data: [{ data: temp }],
        total: tot,
        flag: 1,
        saved: temp[temp.length - 1]?.y || 0,
        // saved: temp[temp.length - 1]
      });
    } else {
      let temp = [];
      for (
        let i = 0;
        i < feesSavedDefault[strategy ? strategy : 0]?.data?.length;
        i++
      ) {
        temp.push({
          x: parseInt(moment(createdAt).format('YYYY')) + i,
          y: feesSavedDefault[strategy ? strategy : 0]?.data[i],
        });
      }
      setGraphData({
        data: [{ data: temp }],
        total: feesSavedDefault[strategy ? strategy : 0]?.total,
        flag: 0,
        saved: temp[temp.length - 1]?.y || 0,
      });
    }
  }, [strategy, sponsor_name, employer_selected, feesSavedData, createdAt]);
  return graphData;
};
